import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import cx from 'classnames';

import './Tabs.scss';

const CaseMenu = ({
  location: { pathname },
  match: { url },
  data,
}) => (
  <div className="tabs">
    {data.map(({
      id,
      path,
      title,
    }) => (
      <RouterLink
        to={`${url}/${path}`}
        key={id}
      >
        <div
          className={cx(
            'tabs__item',
            { 'tabs__item--active': `${url}/${path}` === pathname }
          )}
        >
          {title}
        </div>
      </RouterLink>
    ))}
  </div>
);

CaseMenu.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    path: PropTypes.string,
    title: PropTypes.string,
  })),
};

CaseMenu.defaultProps = {
  data: [],
};

export default withRouter(CaseMenu);



// WEBPACK FOOTER //
// ./src/routes/Case/containers/Tabs/Tabs.js